import "./singleMembershipLandingPage.scss";

import moment from "moment";
import { toastr } from "react-redux-toastr";
import { useEffect, useState } from "react";
import BuyNowButton from "../../BuyNowButton";
import { useDispatch, useSelector } from "react-redux";
import BenefitActivityList from "./BenefitActivityList";
import Button from "../../../../../../common/Buttons/Button";
import Typography from "../../../../../../common/Typography";
import MembershipExpiryBanner from "./MembershipExpiryBanner";
import RedeemableStoresCanvas from "./RedeemableStoresCanvas";
import SbAccordion from "../../../../../../common/SbAccordion";
import MembershipPurchaseCanvas from "./MembershipPurchaseCanvas";
import CustomerSavingAmountCard from "../../CustomerSavingAmountCard";
import ArrowNarrowLeft from "../../../../../../assets/ArrowNarrowLeft";
import { getFullImageUrl } from "../../../../../../../utils/constants/constants";
import { setShortlinkData } from "../../../../../../../redux/actions/shortlinkActions";
import {
  shortlinkFAQs,
  restrictPointsTerm,
  activationSettingTerm,
} from "../../../utils";

const SingleMembershipLandingPage = ({
  currMemb,
  setCurrMemb,
  isShortlink,
  isShowBackBtn,
  activeMockupStatus,
  membPurchaseDetails,
  setMultiMembrshpPage,
  setActiveMockupStatus,
  toggleRedeemableStoresModalInMockup = () => {},
}) => {
  const dispatch = useDispatch();
  const [isAllStores, setIsAllStores] = useState(false);
  const [isMembPurchaseCanvas, toggleMembPurchaseCanvas] = useState(false);
  const [isPurchasedInTestStatus, setPurchasedInTestStatus] = useState(false);

  const user = useSelector((state) => state?.auth?.user);
  const shortLinkData = useSelector((state) => state?.shortLink);
  const storeDets = useSelector((state) => state.store.businessDetails);

  const initData = shortLinkData?.initData;
  const isFilterSubsMembs = initData?.isFilterSubsMembs;
  const subsMembs = shortLinkData?.subscribedMemberships;

  const membership = currMemb?.membership ?? {};
  const membExpiry = membership?.settings?.membership_expiry;
  const expiryDate = isPurchasedInTestStatus
    ? moment().add(membExpiry?.duration, membExpiry?.period).toISOString()
    : currMemb?.expires_at ?? "";
  const textColor = membership?.landing_page_settings?.colors?.text ?? "#000";
  const themeColor =
    membership?.landing_page_settings?.colors?.theme ?? "#FFCA05";
  const logo = membership?.landing_page_settings?.logo;
  const storeName = isShortlink ? initData?.entity_name : storeDets?.name;
  const currencyView = isShortlink
    ? initData?.currency
    : user?.country?.currency_view;
  const shortlinkType = initData?.type;
  const isTestCommMembShortlink =
    shortlinkType === "membership_test_communication";
  const customerId =
    initData?.customer_id || initData?.customer?.id || currMemb?.customer_id;
  const isSubsMembExpired = moment(currMemb?.expires_at).isBefore(
    moment(),
    "day"
  );

  const isShowBuyButton =
    activeMockupStatus === "before_purchase" ||
    (isShortlink
      ? shortlinkType === "membership_test" || isTestCommMembShortlink
        ? !isPurchasedInTestStatus
        : customerId?.length > 0
        ? currMemb?.expires_at
          ? isSubsMembExpired
          : true
        : true
      : false);

  useEffect(() => {
    if (isTestCommMembShortlink) setPurchasedInTestStatus(true);
  }, [isTestCommMembShortlink]);

  useEffect(() => {
    if (membPurchaseDetails?.status) toggleMembPurchaseCanvas(true);
  }, [membPurchaseDetails]);

  const handleBack = () => {
    setCurrMemb({});
    window.scrollTo(0, 0);
    setMultiMembrshpPage(true);
    if (subsMembs?.length > 0 && isFilterSubsMembs === false)
      dispatch(
        setShortlinkData({
          ...initData,
          isFilterSubsMembs: true,
        })
      );
  };

  const handleBuyNow = () => {
    if (isShortlink) {
      if (initData?.is_promotion_active === false) {
        toastr.error(
          "Error",
          initData?.promotion_source === "in_store"
            ? "Please download and print the creative to enable membership purchase for your customers and analyze the revenue from each creative."
            : initData?.promotion_source === "campaign"
            ? "Please activate the campaign to enable membership purchase for your customers and analyze the revenue from the campaign."
            : "This promotion is not active."
        );
        return;
      }
      toggleMembPurchaseCanvas(!isMembPurchaseCanvas);
    } else setActiveMockupStatus("after_purchase");
  };

  return (
    <div className="single-membership-page">
      <div className="smp-brand-head" style={{ backgroundColor: themeColor }}>
        {!isShortlink && (
          <div
            className={`notch ${isShowBackBtn ? "" : "extra-margin-notch"}`}
          />
        )}
        {isShowBackBtn && (
          <Button
            isPlain
            text="Back"
            variant="secondary"
            customClass="back-btn"
            handleClick={handleBack}
            customStyles={{ color: textColor }}
            leftIcon={
              <div className="left-icon">
                <ArrowNarrowLeft height={16} width={16} />
              </div>
            }
          />
        )}
        <div className="smp-brand-header-details">
          <div
            className="card-logo-div"
            style={{
              backgroundColor: textColor,
            }}
          >
            {logo?.length > 0 ? (
              <img
                width="100px"
                alt="card-logo"
                title="Brand Logo"
                src={getFullImageUrl(logo)}
                className="card-logo-image"
              />
            ) : (
              <Typography
                weight="medium"
                customClass="card-logo-name"
                style={{ color: themeColor }}
              >
                {storeName}
              </Typography>
            )}
          </div>

          <Typography
            weight="medium"
            size="display-xxxl"
            style={{ color: textColor }}
            customClass="membership-name"
          >
            {membership?.landing_page_settings?.title}
          </Typography>
          <hr className="divider" style={{ color: textColor }} />
          <Typography
            size="heading-lg"
            style={{ color: textColor }}
            customClass="membership-description"
          >
            {membership?.landing_page_settings?.description}
          </Typography>
        </div>
      </div>
      <div className="smp-body">
        {expiryDate?.length > 0 ? (
          <MembershipExpiryBanner expiryDate={expiryDate} />
        ) : (
          <CustomerSavingAmountCard
            amount={`${currencyView}${membership?.subscription_details?.customer_saves_on_purchase}`}
          />
        )}
        {/* benefits and activity list */}
        <BenefitActivityList
          currMemb={currMemb}
          isShortlink={isShortlink}
          handleRenew={handleBuyNow}
          currencyView={currencyView}
          isPurchasedInTestStatus={isPurchasedInTestStatus}
        />

        {membership?.applicable_stores?.length > 1 && (
          <Button
            isPlain={true}
            customClass="all-store-btn"
            handleClick={() =>
              isShortlink
                ? setIsAllStores(!isAllStores)
                : toggleRedeemableStoresModalInMockup(true)
            }
            text={`${membership?.landing_page_settings?.title} - redeemable at ${membership?.applicable_stores?.length} outlets`}
            rightIcon={
              <ArrowNarrowLeft
                width={20}
                height={20}
                rotate={180}
                color="#0D9298"
              />
            }
          />
        )}
        {/* terms and conditions */}
        {membership?.terms?.length > 0 && (
          <div className="membership-terms">
            <SbAccordion title="Terms and Conditions">
              <ul>
                {membership?.terms?.map(
                  (term) =>
                    term.isSelected && (
                      <li key={term.key}>
                        <Typography size="text-sm">{term.value}</Typography>
                      </li>
                    )
                )}
                {membership?.restrict_points_to_earn && (
                  <li>
                    <Typography size="text-sm">{restrictPointsTerm}</Typography>
                  </li>
                )}
                {membership?.activation_settings?.is_active && (
                  <li>
                    <Typography size="text-sm">
                      {activationSettingTerm}
                    </Typography>
                  </li>
                )}
              </ul>
            </SbAccordion>
          </div>
        )}
        {/* faqs */}
        <div className="membership-faqs">
          <Typography size="display-md" weight="medium" customClass="faq-title">
            FAQs
          </Typography>
          {shortlinkFAQs?.map((faq, i) => (
            <SbAccordion title={faq.question} key={i}>
              <Typography size="text-sm" weight="medium">
                {faq.answer}
              </Typography>
            </SbAccordion>
          ))}
        </div>
        {/* <div className="share-membership-card">
          <div className="left-side">
            <Typography size="display-lg" weight="medium">
              Share this membership with friends
            </Typography>
            <Button
              size="xs"
              text="Share"
              rightIcon={<ArrowNarrowLeft color="#fff" rotate={180} />}
            />
          </div>
        </div> */}
        {membership?.landing_page_settings?.contact_info?.length > 0 && (
          <Typography size="heading-sm" customClass="contact-info">
            Contact us on{" "}
            <Typography size="heading-sm" tag="span">
              {membership?.landing_page_settings?.contact_info}
            </Typography>
          </Typography>
        )}
      </div>
      {isShowBuyButton && (
        <div className={`smp-footer ${isShortlink ? "sticky-smp-footer" : ""}`}>
          <BuyNowButton
            handleClick={handleBuyNow}
            secondaryTextSize="text-sm"
            primaryTextSize="heading-md"
            isShowRenewTxt={
              currMemb?.expires_at
                ? moment(currMemb?.expires_at).isBefore(moment(), "day")
                : false
            }
            data={{
              text_color: textColor,
              theme_color: themeColor,
              expiry: membership?.settings?.membership_expiry,
              price: `${currencyView}${membership?.subscription_details?.price}`,
            }}
          />
        </div>
      )}
      <MembershipPurchaseCanvas
        membership={membership}
        setCurrMemb={setCurrMemb}
        isOpen={isMembPurchaseCanvas}
        isSubsMembExpired={isSubsMembExpired}
        membPurchaseDetails={membPurchaseDetails}
        setPurchasedInTestStatus={setPurchasedInTestStatus}
        toggleCanvas={() => toggleMembPurchaseCanvas(!isMembPurchaseCanvas)}
      />
      <RedeemableStoresCanvas
        isOpen={isAllStores}
        toggleCanvas={() => setIsAllStores(!isAllStores)}
        applicableStores={membership?.applicable_stores || []}
      />
    </div>
  );
};

export default SingleMembershipLandingPage;
